import { CssBaseline, ThemeProvider } from "@mui/material";
import type { ReactNode } from "react";
import theme from "@/theme";

/** Theme wrapper for auth/bootstrap screens rendered outside App. */
export function BadgerAuthShell({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
